import { render, staticRenderFns } from "./historyCardList.vue?vue&type=template&id=708c6244&scoped=true"
import script from "./historyCardList.vue?vue&type=script&lang=js"
export * from "./historyCardList.vue?vue&type=script&lang=js"
import style0 from "./historyCardList.vue?vue&type=style&index=0&id=708c6244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c6244",
  null
  
)

export default component.exports